module.exports = __webpack_public_path__ + "assets/img/vtuber-zgyd.6bdde7c5.png";